export enum OwnershipTransferModalType {
    NONE = 0,
    ERROR_ON_TRANSFER = 1,
    ERROR_TRANSFER_WAS_CANCELED = 2,
    ERROR_TRANSFER_WAS_ALREADY_ACCEPTED_OR_REJECTED_BY_NEW_OWNER = 3,
    ERROR_VIEW_NOT_FOUND = 4,
    WARN_INVALID_FILTER = 5,
    NO_DYNAMIC_VIEW_LICENSE = 6,
}
